export const environment = {
  apiUrl: 'https://v2.school.eduio.io/api/v1',
  production: true,
  sentryDsn: 'https://7c118d0f724e47a89dd67bea56d8167f@o4511338329210880.ingest.us.sentry.io/4511541058535424',
  sentryRelease: 'a36621e2b853a1578e429fa5dc327214136e6f8f',
};
